import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';
import { IVisitorInOutGraph } from 'src/app/models/riskProfile';

@Component({
  selector: 'app-visitor-in-out-bound',
  templateUrl: './visitor-in-out-bound.component.html',
  styleUrls: ['./visitor-in-out-bound.component.scss'],
})
export class VisitorInOutBoundComponent {
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  @Input() set visitorInOutGraphDetails(val: IVisitorInOutGraph[]) {
    if (val) {
      this.visitorInOutGraph = val;
      this.setChartData(val);
    }
  }
  visitorInOutGraph: IVisitorInOutGraph[];
  height = '';
  chartOption: EChartsOption;
  private setChartData(val: IVisitorInOutGraph[]) {
    const copiedDatesArray = val.slice();
    const sortedDate = copiedDatesArray.sort(
      (a, b) =>
        new Date(a.inviteDate).getTime() - new Date(b.inviteDate).getTime()
    );

    const dates = sortedDate.map((item) =>
      new Date(item.inviteDate).toLocaleString('en-US')
    );

    const checkIn = sortedDate.map((item) => item.visitorCheckInCounts);
    const checkOut = sortedDate.map((item) => item.visitorCheckOutCounts);
    const combinedArray = [...checkIn, ...checkOut];
    const maxVal = Math.max(...combinedArray);

    this.chartOption = {
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Check In', 'Check Out'],
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '12%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: dates,
        axisLabel: {
          rotate: dates.length > 8 ? 45 : 0,
          formatter: (value: string) => {
            const date = new Date(value);
            const month = date.toLocaleString('en-us', { month: 'short' });
            const day = date.getDate();
            return `${month} ${day}`;
          },
        },
      },
      yAxis: {
        type: 'value',
        min: 0, // Set the minimum value for the Y-axis
        max: maxVal + 10,
      },
      series: [
        {
          name: 'Check In',
          type: 'line',
          stack: 'inbound',
          data: checkIn,
        },
        {
          name: 'Check Out',
          type: 'line',
          stack: 'outbound',
          data: checkOut,
        },
      ],
      dataZoom: [
        {
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          start: 0, // Start position of the slider (0% of the data)
          end: 100, // End position of the slider (100% of the data)
        },
        {
          type: 'inside',
          xAxisIndex: [0],
          start: 0,
          end: 100,
        },
      ],
    };
  }
}
